module.exports = __webpack_public_path__ + "media/01_ASANBUDAPEST-BASS01.067f8a82.mp3";